import React from "react";
import { Box } from "@mui/material";
import { ItemType } from "../../types/types";
import RelatedProducts from "./RelatedProducts";

type ItemRelatedProps = {
  item: ItemType;
};

/**
 * The related-products band (EB-539).
 *
 * It sits outside the two-column grid and spans the whole container. In the right-hand column it
 * had half the page to work with, so `CardsContainer` — a wrapping flex of 140 px cards — fitted
 * two per row where five now fit.
 *
 * There is no desktop/mobile variant: full width is full width, and mobile was already one column.
 *
 * The separator and the horizontal padding belong to `RelatedProducts`, not here. That component
 * hides relations whose targets turn out to be inactive (EB-520) and can end up rendering nothing
 * at all, and only it knows when — so it carries its own rule out with it rather than leaving one
 * stranded across the page.
 */
const ItemRelated: React.FC<ItemRelatedProps> = ({ item }) => {
  const relations = item.productos_relacionados;

  if (!relations || relations.length === 0) return null;

  return (
    <Box width="100%">
      <RelatedProducts relations={relations} />
    </Box>
  );
};

export default ItemRelated;
